module.exports = __webpack_public_path__ + "static/media/201109_bfresh_aos.fc27a59c.jpg";